import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { AuthorAvatar } from "~/components/author/author-avatar";
import type { plusAuthorCardAuthor$key } from "~/queries/__generated__/plusAuthorCardAuthor.graphql";

import {
  Expertise,
  StyleAuthorCardContainer,
  StyleAuthorInfoContainer,
  StyleAvatarContainer,
  StyledAuthorBio,
  StyledStyleAuthorName,
  StyleNameContainer,
} from "./styles";

export type Props = {
  reference: plusAuthorCardAuthor$key;
};

export const PlusAuthorCard: FunctionComponent<Props> = ({ reference: reference_ }) => {
  const author = useFragment(
    graphql`
      fragment plusAuthorCardAuthor on Author {
        ...authorAvatarAuthor
        ...authorNameAuthor
        ...authorBioAuthor
        areaOfExpertise
      }
    `,
    reference_,
  );

  return (
    <StyleAuthorCardContainer>
      <StyleAvatarContainer>
        <AuthorAvatar height={60} reference={author} width={60} placeholder />
      </StyleAvatarContainer>
      <StyleAuthorInfoContainer>
        <StyleNameContainer>
          <StyledStyleAuthorName reference={author} />
          {!!author.areaOfExpertise?.length && (
            <>
              <span>|</span>
              <Expertise>{author.areaOfExpertise.join(", ").trim()}</Expertise>
            </>
          )}
        </StyleNameContainer>
        <StyledAuthorBio reference={author} />
      </StyleAuthorInfoContainer>
    </StyleAuthorCardContainer>
  );
};

PlusAuthorCard.displayName = "PlusAuthorCard";
